/* eslint-disable jsx-a11y/alt-text */
import MyRegisterModal from "../../components/modal/MyRegisterModal";
import Modal from "react-modal";
import { BsXCircle } from "react-icons/bs";
import { useSelector, useDispatch } from "react-redux";
import { createAccount, updateAccount } from "../../actions/account";
import { logoutSession } from "../../actions/session";
import { loginByUniId } from "../../common/utils";
import { useNavigate } from "react-router-dom";
import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import {
  PACKAGE_DAILY,
  SHOW_MSISDN,
  SHOW_OTP,
  SHOW_PACKAGE,
  SHOW_SUCCESS,
} from "../../common/constant";
import { restApi, restPostApi } from "../../services/httpService";
import {
  buyTurnByOtpUrl,
  buyTurnConfirmUrl,
  buyTurnUrl,
  loadAccountInfoUrl,
  loadHomeDataUrl,
  registerByOtpConfirmUrl,
  registerByOtpConfirmUrlloginUrl,
  registerByOtpUrl,
  registerByUniserviceUrl,
} from "../../common/url";
import {
  error,
  httpSuccess,
  success,
  unauthorized,
  waitingForOtp,
} from "../../common/errorCode";
import { isNotNull } from "../../common/utils";
import MyResultModal from "../../components/modal/MyResultModal";
import { useTranslation } from "react-i18next";
import { loginUrl, uniIdLoginUrl } from "../../common/url";
import { CLIENTID } from "../../common/constant";
import { purgeData, store } from "../..";
import MyBuyTurnModal from "../../components/modal/MyBuyTurnModal";
import ReactLoading from "react-loading";
import ClipLoader from "react-spinners/ClipLoader";
import circular1 from "../../assets/img/circular1.png";
import circular2 from "../../assets/img/circular_2.png";
import pweekly from "../../assets/img/weeky_prize.png";
import p1st from "../../assets/img/1st_prize.png";
import p2nd from "../../assets/img/2nd_prize.png";
import p3rd from "../../assets/img/3rd_prize.png";
import giftIcon from "../../assets/img/gift 1.png";
import cupBadge from "../../assets/img/gold cup.png";
import coinDeco1 from "../../assets/img/coin.png";
import coinDeco2 from "../../assets/img/coin_3.png";
import Select from "react-select";
import {
  setDataToModal,
  setShowBuyTurnModal,
  setShowResultModal,
} from "../../actions/modal";

const titleStyle = {
  fontWeight: "400",
  lineHeight: "20px",
  fontSize: "13px",
  textAlign: "end",
  display: "inherit",
};

const infoStyle = {
  fontWeight: "700",
  lineHeight: "20px",
  fontSize: "16px",
  textAlign: "end",
  display: "inherit",
};

const colourStyles = {};

const welcomeModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    padding: "1px",
    border: "none",
    background: "transparent",
    minWidth: "300px",
    maxWidth: "340px",
    width: "90%",
    borderRadius: "28px",
    overflow: "visible",
  },
};

const playNowModalStyles = welcomeModalStyles;

var msisdn = "";
var packBuy = "";
let requestId = "";
const HomePage = () => {
  const [modalRegisterIsOpen, setModalRegisterIsOpen] = React.useState(false);
  const [modalBuyTurnIsOpen, setModalBuyTurnIsOpen] = React.useState(false);
  const [modalResultIsOpen, setModalResultIsOpen] = React.useState(false);
  const [modalWelcomeIsOpen, setModalWelcomeIsOpen] = React.useState(false);
  const [modalPlayNowIsOpen, setModalPlayNowIsOpen] = React.useState(false);

  const [stepRegister, setStepRegister] = React.useState(SHOW_MSISDN);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [accountRedux, setAccount] = React.useState({
    accountUser: { msisdn: "" },
  });
  // const [regInfosRedux, setRegInfos] = React.useState({});

  const [dailyTerm, setDailyTerm] = React.useState({});
  const [weeklyTerm, setWeeklyTerm] = React.useState({});
  const [selectTerm, setSelectTerm] = React.useState([]);
  const [showRegister, setShowRegister] = React.useState(true);

  // let options = [
  // { value: '1', label: '08/02/2023' },
  // { value: '2', label: '09/02/2023' },
  // { value: '3', label: '10/02/2023' }
  // ]

  const { t } = useTranslation();

  // check account logined
  const navigate = useNavigate();

  const account = useSelector((state) => state.AccountReducer);
  const tokenInfo = useSelector((state) => state.SessionReducer);

  const dispatch = useDispatch();

  console.log("account: " + JSON.stringify(account));

  React.useEffect(() => {
    // load account again
    console.log("Loading account info...");
    // setModalWelcomeIsOpen(true);
    // setModalPlayNowIsOpen(true);

    loadAccountInfo();
    loadHomeData("");
  }, []);

  async function loadAccountInfo() {
    let res = await restPostApi(loadAccountInfoUrl, {}, tokenInfo);

    console.log("res: " + JSON.stringify(res));

    if (res != null) {
      console.log("status: " + res.status);

      let errorCode = error;
      let message = "ERROR";
      if (res.status === httpSuccess) {
        console.log("errorCode: " + res.data.errorCode);
        errorCode = res.data.errorCode;
        if (String(res.data.errorCode) === success) {
          // create account
          let accountInfo = {
            accountUser: res.data.data.accountUser,
            regInfos: res.data.data.regInfos,
          };
          dispatch(updateAccount(accountInfo));

          // setRegInfos(res.data.data.regInfos);
          // check is registered for at least one auction
          const isRegisteredForAtLeastOneAuction =
            isNotNull(res.data.data.regInfos) &&
            res.data.data.regInfos.length > 0 &&
            res.data.data.regInfos.some((regInfo) => regInfo.status === 1);
          if (isRegisteredForAtLeastOneAuction) {
            console.log("User has registered for at least one auction.");
            setShowRegister(false);
            setModalPlayNowIsOpen(true);
          } else {
            console.log("User has not registered for any auction.");
            setModalWelcomeIsOpen(true);
          }

          setAccount(accountInfo);
          return;
        } else {
          console.log("message: " + res.data.message);
          message = res.data.message;
        }
      }
      store.dispatch(
        setDataToModal({
          type: "result",
          dataToModal: {
            errorCode: errorCode,
            message: message,
          },
        }),
      );
    }
  }

  function registerHandler() {
    console.log("Show Modal");
    setStepRegister(SHOW_MSISDN);
    setErrorMessage("");
    setModalRegisterIsOpen(!modalRegisterIsOpen);
    // store.dispatch(setShowResultModal(!isShowSubmitModal));
  }

  function welcomeRegisterHandler() {
    setModalWelcomeIsOpen(false);
    setStepRegister(SHOW_MSISDN);
    setErrorMessage("");
    modalRegisterConfirm(accountRedux.accountUser.msisdn);
  }

  function playNowHandler() {
    setModalPlayNowIsOpen(false);
    navigate("/play");
  }

  function buyTurnHandler() {
    store.dispatch(setShowBuyTurnModal(true));
  }

  async function modalRegisterConfirm(data) {
    console.log("data confirm: " + data);
    if (stepRegister === SHOW_MSISDN) {
      msisdn = data;
      let res = await restPostApi(
        registerByUniserviceUrl,
        {
          msisdn: data,
          packageName: PACKAGE_DAILY,
        },
        tokenInfo,
      );

      console.log("res: " + JSON.stringify(res));

      if (res != null) {
        console.log("status: " + res.status);

        let errorCode = error;
        let message = "ERROR";
        if (res.status === httpSuccess) {
          console.log("errorCode: " + res.data.data.url);
          window.open(res.data.data.url, "_self", "noopener,noreferrer");
          // errorCode = res.data.errorCode;
          // if (res.data.errorCode === waitingForOtp) {
          //   // get requestId
          //   requestId = res.data.data.requestId;
          //   console.log("requestId: " + requestId);
          //   setStepRegister(SHOW_OTP);
          //   return;
          // } else {
          //   console.log("message: " + res.data.message);
          //   setErrorMessage(res.data.message);
          //   message = res.data.message;
          // }
        } else {
          console.log("message: " + res.data);
          setErrorMessage(res.data);
          message = res.data;
          setModalRegisterIsOpen(!modalRegisterIsOpen);
          // setModalResultIsOpen(true);
        }
        // store.dispatch(setDataToModal({
        //     type: 'result',
        //     dataToModal: {
        //         errorCode: errorCode,
        //         message: message
        //     }
        // }));
      } else {
        console.log("message: Exception");
        setErrorMessage("Exception");

        setModalRegisterIsOpen(!modalRegisterIsOpen);
        // setModalResultIsOpen(true);
        // store.dispatch(setDataToModal({
        //     type: 'result',
        //     dataToModal: {
        //         errorCode: error,
        //         message: "Exception"
        //     }
        // }));
      }
    } else if (stepRegister === SHOW_OTP) {
      if (!isNotNull(data) || data == "") {
        setErrorMessage("Please check your OTP");
        return;
      }
      let res = await restPostApi(
        registerByOtpConfirmUrl,
        {
          msisdn: msisdn,
          packageName: PACKAGE_DAILY,
          requestId: requestId,
          otp: data,
        },
        tokenInfo,
      );
      console.log("status: " + res.status);
      let errorCode = error;
      let message = "ERROR";

      if (res.status === httpSuccess) {
        console.log("errorCode: " + res.data.errorCode);
        errorCode = res.data.errorCode;
        if (String(res.data.errorCode) === success) {
          console.log("message: " + res.data.message);

          setErrorMessage(res.data.message);
          setModalRegisterIsOpen(!modalRegisterIsOpen);
          // setModalResultIsOpen(!modalResultIsOpen);

          // update account
          let accountInfo = {
            accountUser: res.data.data.accountUser,
            regInfos: res.data.data.regInfos,
          };
          dispatch(updateAccount(accountInfo));

          message = res.data.message;
        } else {
          console.log("message: " + res.data.message);
          setErrorMessage(res.data.message);
          // message = res.data.message;
          return;
        }
      } else {
        console.log("message: " + res.data);
        setErrorMessage(res.data);
        // message = res.data;
        return;
      }
      store.dispatch(
        setDataToModal({
          type: "result",
          dataToModal: {
            errorCode: errorCode,
            message: message,
          },
        }),
      );
    } else {
      setModalRegisterIsOpen(!modalRegisterIsOpen);
    }
  }

  async function loadHomeData(termId) {
    // console.log("getI18n: " + JSON.stringify(t.language));

    let res = await restPostApi(
      loadHomeDataUrl,
      {
        termInfoId: termId,
      },
      tokenInfo,
    );

    console.log("res: " + JSON.stringify(res));

    if (res != null) {
      console.log("status: " + res.status);

      if (res.status === httpSuccess) {
        console.log("errorCode: " + res.data.errorCode);
        if (String(res.data.errorCode) === success) {
          if (isNotNull(res.data.data.homeData.weeklyTerm)) {
            setWeeklyTerm(res.data.data.homeData.weeklyTerm);
          }
          if (isNotNull(res.data.data.homeData.dailyTerms)) {
            setDailyTerm(res.data.data.homeData.dailyTerms);
            let options = [];
            for (
              let k = 0;
              k < res.data.data.homeData.dailyTerms.termInfos.length;
              k++
            ) {
              let termInfoGet = res.data.data.homeData.dailyTerms.termInfos[k];
              console.log("termInfoGet.id: " + termInfoGet.id);
              options.push({
                value: termInfoGet.id,
                label: termInfoGet.fromTime + " - " + termInfoGet.toTime,
              });
            }
            setSelectTerm(options);
          }
        } else {
          console.log("message: " + res.data.message);
        }
      } else {
        console.log("message: " + res.data);
      }
    } else {
      console.log("message: Exception");
    }
  }
  function chooseTermClick(value) {
    loadHomeData(value);
  }

  return (
    <div>
      <div className="fixed  top-[-2%] left-[30%]">
        <img src="../assets/images/coin.png" className="" />
      </div>
      <div className="fixed z-[1]  blend-mode top-[18%] left-[6%]">
        <img src="../assets/images/Light.png" className="blink-effect" />
      </div>
      <div className="fixed  top-[0%] left-[0%]">
        <img src={circular1} className="" />
      </div>
      <div className="fixed top-[0%] left-[0%]">
        <img src={circular2} className="" />
      </div>
      <div className="pt-[10px] w-full flex justify-between items-center">
        {showRegister ? (
          <div
            className="btn-c-2 text-c-1 font-z-15 uppercase "
            onClick={registerHandler}
            style={{ zIndex: "100" }}
          >
            {t("registerNow")}
          </div>
        ) : (
          <div></div>
        )}

        {/* <div
          className="btn-c-3 text-c-1 text-c-4 font-z-15"
          onClick={buyTurnHandler}
          style={{ zIndex: "100" }}
        >
          {t("buyMore")}
        </div> */}
      </div>

      <Modal
        isOpen={modalWelcomeIsOpen}
        onRequestClose={() => setModalWelcomeIsOpen(false)}
        style={welcomeModalStyles}
        overlayClassName="welcome-modal-overlay"
        contentLabel="Welcome Modal"
      >
        <div className="welcome-modal-content">
          <img src={coinDeco1} className="modal-coin-deco coin-deco-left" />
          <img src={coinDeco2} className="modal-coin-deco coin-deco-right" />
          <span className="modal-sparkle sparkle-a" />
          <span className="modal-sparkle sparkle-b" />
          <span className="modal-sparkle sparkle-c" />

          <div className="welcome-modal-badge-halo" />
          <img src={giftIcon} className="welcome-modal-badge" />
          <div
            className="welcome-modal-close"
            onClick={() => setModalWelcomeIsOpen(false)}
          >
            <BsXCircle style={{ height: "1.8rem", width: "1.8rem" }} />
          </div>

          <div className="welcome-modal-prizes">
            <img src={p2nd} className="welcome-prize-side" />
            <img src={p1st} className="welcome-prize-main" />
            <img src={p3rd} className="welcome-prize-side" />
          </div>

          <div className="welcome-modal-title">{t("joinUwin")}</div>
          <div className="welcome-modal-subtitle">
            {t("inviteRegisterSubtitle")}
          </div>

          <button
            className="welcome-modal-btn"
            onClick={welcomeRegisterHandler}
          >
            {t("registerNow").toUpperCase()}
          </button>
        </div>
      </Modal>

      <Modal
        isOpen={modalPlayNowIsOpen}
        onRequestClose={() => setModalPlayNowIsOpen(false)}
        style={playNowModalStyles}
        overlayClassName="welcome-modal-overlay playnow-modal-overlay"
        contentLabel="Play Now Modal"
      >
        <div className="welcome-modal-content playnow-modal-content">
          <img src={coinDeco1} className="modal-coin-deco coin-deco-left" />
          <img src={coinDeco2} className="modal-coin-deco coin-deco-right" />
          <span className="modal-sparkle sparkle-a" />
          <span className="modal-sparkle sparkle-b" />
          <span className="modal-sparkle sparkle-c" />

          <div className="welcome-modal-badge-halo playnow-badge-halo" />
          <img src={cupBadge} className="welcome-modal-badge" />
          <div
            className="welcome-modal-close"
            onClick={() => setModalPlayNowIsOpen(false)}
          >
            <BsXCircle style={{ height: "1.8rem", width: "1.8rem" }} />
          </div>

          <div className="welcome-modal-prizes">
            <img src={p2nd} className="welcome-prize-side" />
            <img src={p1st} className="welcome-prize-main" />
            <img src={p3rd} className="welcome-prize-side" />
          </div>

          <div className="welcome-modal-title playnow-modal-title">
            {t("welcomeBackTitle")}
          </div>
          <div className="welcome-modal-subtitle">
            {t("welcomeBackSubtitle").replace(
              "%turn%",
              isNotNull(accountRedux.accountUser.totalTurns)
                ? accountRedux.accountUser.totalTurns
                : 0,
            )}
          </div>

          <button
            className="welcome-modal-btn playnow-modal-btn"
            onClick={playNowHandler}
          >
            {t("playNow").toUpperCase()}
          </button>
        </div>
      </Modal>

      <MyRegisterModal
        isOpenOtp={modalRegisterIsOpen}
        setOpenOtp={() => setModalRegisterIsOpen(!modalRegisterIsOpen)}
        typeModal={stepRegister}
        dataInit={accountRedux.accountUser.msisdn}
        confirmClick={modalRegisterConfirm}
        errorMessage={errorMessage}
      />

      <MyResultModal
        isOpenOtp={modalResultIsOpen}
        setOpenOtp={() => setModalResultIsOpen(!modalResultIsOpen)}
        errorMessage={errorMessage}
      />

      <div className="py-[10px]" style={{ margin: "40px 0px" }}>
        <div className="text-c-1 w-full justify-center">
          {t("havexAuctionTimes").replace(
            "%turn%",
            accountRedux.accountUser.totalTurns,
          )}
          <br />
          {t("joinUwin")}
        </div>
      </div>
      <div className=" my-[20px] bg-[#54041d] w-full h-[93px] rounded-[30px] relative">
        <div className="absolute right-[24px] w-full h-full">
          <div className="flex justify-end items-center h-full">
            <div>
              <div
                className="text-c-2 text-center justify-center"
                style={{ fontSize: "10px", lineHeight: "5px" }}
              >
                on {isNotNull(weeklyTerm) ? weeklyTerm.dateRun : ""}
              </div>
              <div className="text-title-1">
                {isNotNull(weeklyTerm) ? weeklyTerm.prize : ""}
              </div>
              <div
                className="text-c-2 text-center justify-center"
                style={{ lineHeight: "10px" }}
              >
                {isNotNull(weeklyTerm) ? weeklyTerm.type : "KIP"}
              </div>
            </div>
          </div>
        </div>
        <div className="absolute top-[50%] translate-y-[-50%] left-[-15px]">
          <img src={pweekly} />
        </div>
      </div>

      <div className="my-[20px]">
        <div className="w-full flex justify-center">
          <div
            style={{
              width: "100%",
              maxWidth: "250px",
              marginBottom: "20px",
            }}
          >
            <div
              className="text-c-1 w-full font-z-18 justify-center"
              style={{
                textAlign: "center",
                margin: "10px 0",
              }}
            >
              {t("resultOfDay")}
            </div>
            <div
              className="text-c-2 font-z-10 justify-center"
              style={{ fontSize: "15px" }}
            >
              {dailyTerm.dayReport}
            </div>
            <div className="select-container">
              <Select
                key={"abc"}
                options={selectTerm}
                styles={colourStyles}
                onChange={(e) => chooseTermClick(e.value)}
                placeholder={selectTerm.length > 0 ? selectTerm[0].label : ""}
              />
            </div>
          </div>
        </div>

        <div
          className="w-full flex flex-col gap-4"
          style={{ marginBottom: "150px" }}
        >
          {(() => {
            if (
              isNotNull(dailyTerm.userPrizes) &&
              dailyTerm.userPrizes.length > 0
            ) {
              let dataRender = [];
              for (let i = 0; i < dailyTerm.userPrizes.length; i++) {
                dataRender.push(
                  <div id={i} className="card">
                    <div className="absolute top-[50%] translate-y-[-50%] left-[-15px] blend-mode">
                      <img
                        src={
                          dailyTerm.userPrizes[i].priority == 0
                            ? p1st
                            : dailyTerm.userPrizes[i].priority == 1
                              ? p2nd
                              : dailyTerm.userPrizes[i].priority == 2
                                ? p3rd
                                : p3rd
                        }
                      />
                    </div>
                    <div className="w-full h-full flex justify-end items-center">
                      <div style={{ textAlign: "end", display: "initial" }}>
                        <div className="text-c-2 font-z-10" style={titleStyle}>
                          {t("winner")}
                        </div>
                        <div
                          className="text-c-2 font-z-10 justify-center"
                          style={infoStyle}
                        >
                          {isNotNull(dailyTerm)
                            ? dailyTerm.userPrizes[i].msisdn
                            : ""}
                        </div>
                        <div className="text-c-2 font-z-10" style={titleStyle}>
                          {t("auctionAmount")}
                        </div>
                        <div
                          className="text-c-2 font-z-10 justify-center"
                          style={infoStyle}
                        >
                          {isNotNull(dailyTerm)
                            ? dailyTerm.userPrizes[i].value
                            : ""}{" "}
                          {"KIP"}
                        </div>
                      </div>
                    </div>
                  </div>,
                );
              }
              return dataRender;
            } else {
              return (
                <div
                  className="text-c-1 w-full font-z-18 justify-center"
                  style={{
                    textAlign: "center",
                    margin: "10px 0",
                  }}
                >
                  {t("noWinner")}
                </div>
              );
            }
          })()}
        </div>
      </div>
    </div>
  );
};

export default HomePage;
